export default "__VITE_ASSET__4d7a3263__"